import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Kontakt, Kontakt2 } from 'app/api/iop-katalog-institucija-api-reference';

const emailPattern = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4};?)+$/;

@Component({
  selector: 'app-kontakt',
  templateUrl: './kontakt.component.html',
  styleUrls: ['./kontakt.component.scss']
})
export class KontaktComponent implements OnInit, OnChanges {
  @Input() pregledPodataka: boolean = false;

  translatePrefix: string = "features.katalogOrgana.pretraga.";
  generalErrors: string = "general.errors.";

  form: FormGroup;

  @Input()
  prosledjeniKontakt: Kontakt;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm();
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      internetAdresa: new FormControl<string>(this.prosledjeniKontakt.internetAdresa, [Validators.maxLength(200)]),
      adresaEPoste: new FormControl<string>(this.prosledjeniKontakt.adresaEPoste,
        [Validators.maxLength(100), Validators.pattern(emailPattern)]
      ),
      telefon: new FormControl<string>(this.prosledjeniKontakt.telefon, [Validators.maxLength(50)]),
    })

    if (this.pregledPodataka) this.form.disable();
  }

  napraviKontakt(kontaktOrgana: Kontakt | Kontakt2): Kontakt | Kontakt2 {
    kontaktOrgana.internetAdresa = this.internetAdresa.value?.trim() == "" ? null : this.internetAdresa.value;
    kontaktOrgana.adresaEPoste = this.adresaEPoste.value?.trim() == "" ? null : this.adresaEPoste.value;
    kontaktOrgana.telefon = this.telefon.value?.trim() == "" ? null : this.telefon.value;

    if (kontaktOrgana instanceof Kontakt2) {
      kontaktOrgana.id = this.prosledjeniKontakt.id;
    }

    return kontaktOrgana;
  }

  get internetAdresa() {
    return this.form.get("internetAdresa");
  }
  get adresaEPoste() {
    return this.form.get("adresaEPoste");
  }
  get telefon() {
    return this.form.get("telefon");
  }
}
